import React from 'react';

const GreenArrowIcon = function () {
  return (
    <svg width="16px" height="15px" viewBox="0 0 16 15" version="1.1">
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Onboarding-Search" transform="translate(-1284.000000, -1003.000000)" fill="#1EC252" fillRule="nonzero">
          <g id="Group-8" transform="translate(200.000000, 981.000000)">
            <g id="Group-4" transform="translate(1019.000000, 11.000000)">
              <path d="M74.0775058,11.2716953 C73.8976989,11.0518434 73.6114837,10.9544808 73.3382371,11.0202161 C73.0649905,11.0859514 72.8516402,11.3034953 72.787172,11.5821128 C72.7227039,11.8607303 72.8181897,12.1525713 73.0338035,12.3359125 L78.3587728,17.771934 L65.7463494,17.771934 C65.3517922,17.793279 65.0426046,18.125714 65.0426046,18.5285924 C65.0426046,18.9314708 65.3517922,19.2639058 65.7463494,19.2852508 L78.3587728,19.2852508 L73.0254539,24.714887 C72.7466019,25.0126509 72.7466019,25.4813403 73.0254539,25.7791042 C73.1637067,25.9205175 73.3514786,26 73.547305,26 C73.7431315,26 73.9309034,25.9205175 74.0691562,25.7791042 L80.6653549,19.0532515 C80.80721,18.9140219 80.8873652,18.7219079 80.8873652,18.5211429 C80.8873652,18.3203779 80.80721,18.1282639 80.6653549,17.9890343 L74.0775058,11.2716953 Z" id="Path-Copy-2" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
export default GreenArrowIcon;
